import { actionTypes } from "../constants/action-types"


export const setInsights = (payload) => {
    return {
        payload : payload,
        type : actionTypes.GET_INSIGHTS
    }
}